import React from 'react';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';

import SimpleSelect from '../components/SimpleSelect';
import { isActiveTypes } from '../utils/enums';

const FiltersDisplay = ({
    setSearchTerm, 
    setStatusFilter,
    searchTerm
}) => {


        return (
           <div style={{ display: 'flex' }}>
                <TextField
                        id="search-input" variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{ startAdornment: (<InputAdornment position="start"> <SearchIcon /> </InputAdornment>) }}
                        style={styles['search']}
                        autoComplete="off"
                        label="Search by name or type"
                />
                <SimpleSelect 
                        title="Is Active"
                        onChange={(val) => setStatusFilter(val)}
                        options={
                            [
                                { label: 'All', value: 'All', key: isActiveTypes.ALL },
                                { label: 'Active', value: true, key: isActiveTypes.ACTIVE }, 
                                { label: 'In Active', value: false, key: isActiveTypes.INACTIVE }
                            ]
                        }
                />
           </div>
        )
}

const styles = {
    'search': {
        width: '50%',
        margin: 10,
        float: 'left'
    }
}

export default FiltersDisplay;

